import { useRef } from 'react';
import { VariableSizeList } from 'react-window';

import { useBreakpoint } from '@/hooks/useBreakpoint';

import {
    ListItemType,
    SecretListId,
    SecurityAuditGroupSize,
    SecurityAuditSecretSize,
    SecurityAuditSecretWithAdditionalSize,
} from '../../constants';
import { useSecretsListOffset } from '../../hooks/useSecretsListOffset';
import type { ListItemSize, SecurityAuditLeaksItem } from '../../types';
import { SecurityAuditLeaksItemRenderer } from '../SecurityAuditLeaksItemRenderer';

export interface SecurityAuditLeaksSecretsListProps {
    data: SecurityAuditLeaksItem[];
    height: number;
    width: number;
}

export const SecurityAuditLeaksSecretsList = ({ data, height, width }: SecurityAuditLeaksSecretsListProps) => {
    const listRef = useRef<VariableSizeList<typeof data>>(null);

    const handleOffset = useSecretsListOffset(SecretListId.AUDIT_LEVEL_LIST, listRef);

    const isMin768 = useBreakpoint('sm');

    return (
        <VariableSizeList<typeof data>
            ref={listRef}
            height={height}
            width={width}
            itemData={data}
            itemCount={data.length}
            estimatedItemSize={isMin768 ? SecurityAuditSecretSize.desktop : SecurityAuditSecretSize.mobile}
            itemSize={index => {
                const item = data[index];

                let size: ListItemSize = SecurityAuditGroupSize;

                if (item.listItemType === ListItemType.SECRET) {
                    size = item.ignoreSecurityReport ? SecurityAuditSecretWithAdditionalSize : SecurityAuditSecretSize;
                }

                return isMin768 ? size.desktop : size.mobile;
            }}
            itemKey={index => data[index].key}
            onScroll={({ scrollOffset }) => {
                handleOffset(scrollOffset);
            }}
        >
            {/* @ts-expect-error */}
            {SecurityAuditLeaksItemRenderer}
        </VariableSizeList>
    );
};
